'use client';
import React, { useState } from 'react';

import Icon from '@/components/ui/AppIcon';
import AppImage from '@/components/ui/AppImage';

const galleryImages = [
{ src: "https://img.rocket.new/generatedImages/rocket_gen_img_10125b608-1784689489979.png", alt: 'Corporate golf day group photo at Maritzburg Golf Club' },
{ src: "https://img.rocket.new/generatedImages/rocket_gen_img_139092c7e-1784689489908.png", alt: 'Golfers enjoying a corporate golf day at Maritzburg Golf Club' }];


export default function CorporateSection() {
  const [activeImg, setActiveImg] = useState(0);

  return (
    <section className="py-20 bg-card">
      <div className="max-w-screen-2xl mx-auto px-4 lg:px-8 xl:px-10">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 items-center">
          {/* Content */}
          <div>
            <span className="text-accent font-semibold text-sm tracking-widest uppercase">Corporate & Groups</span>
            <h2 className="text-3xl md:text-4xl font-bold text-foreground mt-2 mb-4">
              Corporate Golf Days &amp; Group Bookings
            </h2>
            <p className="text-muted-foreground text-base leading-relaxed mb-4">
              Hosting a golf day at Maritzburg Golf Club offers you and your guests much more than just an exceptional round of golf — it&apos;s an experience marked by our team&apos;s attention to detail and signature personal touch.
            </p>
            <p className="text-muted-foreground text-base leading-relaxed mb-6">
              We handle everything for groups of <strong className="text-foreground">20 to 120 golfers</strong>, from registration and scoring to prize-giving and even arranging custom-branded golf apparel for your event. Our goal is to make planning your corporate or group golf day simple, seamless, and enjoyable — all while delivering outstanding service at competitive rates.
            </p>

            <div className="grid grid-cols-2 gap-4 mb-8">
              {[
              { icon: 'UsersIcon', label: '20–120 Golfers', sub: 'Groups of all sizes' },
              { icon: 'TrophyIcon', label: 'Full Event Management', sub: 'Registration to prize-giving' },
              { icon: 'ShoppingBagIcon', label: 'Custom Branded Apparel', sub: 'For your event' },
              { icon: 'StarIcon', label: 'Competitive Rates', sub: 'Outstanding value' }].
              map((item) =>
              <div key={item.label} className="flex items-start gap-3 p-3 rounded-lg bg-background border border-border">
                  <div className="w-9 h-9 rounded-lg gradient-primary flex items-center justify-center shrink-0">
                    <Icon name={item.icon as Parameters<typeof Icon>[0]['name']} size={18} variant="outline" className="text-white" />
                  </div>
                  <div>
                    <div className="text-foreground font-semibold text-sm">{item.label}</div>
                    <div className="text-muted-foreground text-xs">{item.sub}</div>
                  </div>
                </div>
              )}
            </div>

            <div className="flex flex-col sm:flex-row gap-3">
              <a
                href="tel:0333962356"
                className="btn-gold px-6 py-3 rounded-xl text-sm font-bold inline-flex items-center justify-center gap-2">
                
                <Icon name="PhoneIcon" size={16} variant="outline" />
                (033) 396 2356
              </a>
              <a
                href="mailto:golf@maritzburggolfclub.co.za"
                className="px-6 py-3 rounded-xl text-sm font-semibold text-primary border-2 border-primary hover:bg-primary hover:text-white transition-all duration-150 inline-flex items-center justify-center gap-2">
                
                <Icon name="EnvelopeIcon" size={16} variant="outline" />
                golf@maritzburggolfclub.co.za
              </a>
            </div>
          </div>

          {/* Image carousel */}
          <div>
            <div className="relative rounded-2xl overflow-hidden aspect-[4/3] mb-4">
              <AppImage
                src={galleryImages[activeImg]?.src}
                alt={galleryImages[activeImg]?.alt}
                fill
                className="object-cover" />
              
            </div>
            <div className="flex gap-3 justify-center">
              {galleryImages.map((img, idx) =>
              <button
                key={`corp-img-${idx}`}
                onClick={() => setActiveImg(idx)}
                className={`w-16 h-12 rounded-lg overflow-hidden border-2 transition-all ${activeImg === idx ? 'border-primary' : 'border-transparent opacity-60'}`}>
                
                  <AppImage src={img.src} alt={img.alt} width={64} height={48} className="object-cover w-full h-full" />
                </button>
              )}
            </div>
          </div>
        </div>
      </div>
    </section>);

}